import React, { useState, useEffect } from 'react';
import {
	Card,
	Col,
	Row,
	Typography,
	Checkbox,
	Dropdown,
	Modal,
	Select,
	Empty,
	Pagination
} from 'antd';
import moment from 'moment';
import _ from 'lodash';
import axios from 'axios';
import env from '../../../../../environment';
import authClient from '../../../../../Auth/Auth';
import { CloseOutlined, FileSearchOutlined } from '@ant-design/icons';
import { useStringFlagValue } from '@openfeature/react-sdk';
import { FilterIcon } from 'hugeicons-react';

const { Text } = Typography;

function FilterTask({
	notesArray,
	setShowMortgageNoteModal,
	setShowMortgageNoteFromImageModal,
	operationId
}) {
	const profile = authClient.getProfile();
	const notesVersion = useStringFlagValue('notes-version', 'v1');
	const [noteArray, setNoteArray] = useState(notesArray);
	const [modal, contextHolder] = Modal.useModal();

	// V2
	const [requestParams, setRequestParams] = useState({
		page: 1,
		limit: 10,
		order: {
			createdAt: 'DESC'
		},
		where: {
			refEntity: 'OPERATION',
			refId: operationId
		}
	});
	const [notesList, setNotesList] = useState([]);
	const [totalItems, setTotalItems] = useState(0);
	const [totalPages, setTotalPages] = useState(0);
	const userId = profile?.userId;

	const notesToRender = notesVersion === 'v1' ? noteArray : notesList;

	useEffect(() => {
		if (!notesArray) return;

		const filters = ['other', 'call', 'task'];

		filterNotesV1(filters, notesArray);
	}, [notesArray]);

	useEffect(() => {
		if (notesVersion === 'v2' && operationId) {
			axios
				.post(`${env.api.url}/notes/find`, requestParams, {
					headers: {
						Authorization: `Bearer ${authClient.getToken()}`
					}
				})
				.then((res) => {
					setNotesList(res?.data?.data?.items || []);
					setTotalItems(res?.data?.data?.totalItems || 0);
					setTotalPages(res?.data?.data?.totalPages || 0);
				})
				.catch((err) => {
					console.error('Error fetching notes:', err);
				});
		}
	}, [operationId, notesVersion, requestParams]);

	const filterNotesV1 = (filter, notes) => {
		const tmpArray = [];
		setNoteArray(undefined);

		for (let i = 0; i < filter.length; i++) {
			if (filter[i] === 'call') {
				tmpArray.push(
					_.filter(notes, function (n) {
						return (
							n.body.includes('ha realizado una llamada') ||
							n.body.includes('ha recibido una llamada')
						);
					})
				);
			}
			if (filter[i] === 'task') {
				tmpArray.push(
					_.filter(notes, function (n) {
						return (
							n.body.startsWith('Ha creado una') ||
							n.body.startsWith('Ha finalizado la tarea') ||
							n.body.startsWith('Ha re-agendado la tarea') ||
							n.body.startsWith('Ha editado la tarea')
						);
					})
				);
			}
			if (filter[i] === 'other') {
				tmpArray.push(
					_.filter(notes, function (n) {
						return (
							!n.body.startsWith('Ha creado una') &&
							!n.body.startsWith('Ha finalizado la tarea') &&
							!n.body.startsWith('Ha re-agendado la tarea') &&
							!n.body.includes('ha realizado una llamada') &&
							!n.body.includes('Ha editado la tarea') &&
							!n.body.includes('ha recibido una llamada')
						);
					})
				);
			}
		}
		const tmp = _.reduceRight(
			tmpArray,
			function (flattened, other) {
				return flattened.concat(other);
			},
			[]
		);
		const sort = _.orderBy(tmp, ['date'], ['desc']);
		setNoteArray(sort);
	};

	const filterNotesV2 = (values) => {
		const baseFilter = {
			refEntity: 'OPERATION',
			refId: operationId
		};

		const typeValues = values.filter((v) => ['TASKS', 'CALLS', 'OTHERS'].includes(v));

		const roleMap = {
			DOCUMENT_MANAGER: 'prerisk',
			RISK: 'risk'
		};

		const salesAgentType = values.map((v) => roleMap[v]).filter((id) => Boolean(id));

		const filters = [
			typeValues.length && {
				...baseFilter,
				type: { _type: 'in', _value: typeValues }
			},
			values.includes('USER') && {
				...baseFilter,
				userId: { _type: 'in', _value: [userId] }
			},
			salesAgentType.length && {
				...baseFilter,
				salesAgentType: { _type: 'in', _value: salesAgentType }
			}
		].filter(Boolean);

		setRequestParams?.((prev) => ({
			...prev,
			page: 1,
			where: filters.length > 0 ? filters : baseFilter
		}));
	};

	const renderText = (text) => {
		text = text.replace(/\n/g, '<br />');

		return text;
	};

	const handlePaginationChange = (page, pageSize) => {
		setRequestParams((prev) => ({
			...prev,
			page,
			limit: pageSize
		}));
	};

	const addNoteMenuClick = (e) => {
		if (
			e.key === 'image-gpt' &&
			setShowMortgageNoteFromImageModal &&
			typeof setShowMortgageNoteFromImageModal === 'function'
		) {
			setShowMortgageNoteFromImageModal(true);
		}
	};

	return (
		<Col lg={16} xs={24} style={{ marginTop: '27px' }}>
			<Row gutter={24} justify={'space-between'}>
				<Col lg={3} xs={3}>
					<div>
						<Text
							style={{
								fontSize: '14px',
								fontWeight: '600',
								color: '#2F4858'
							}}>
							Notas
						</Text>
					</div>
				</Col>
				<Col span={21} style={{ display: 'flex', justifyContent: 'end', gap: 8 }}>
					{notesVersion === 'v1' ? (
						<Checkbox.Group
							onChange={(e) => filterNotesV1(e, notesArray)}
							defaultValue={['other', 'call', 'task']}
							style={{ width: '100%' }}>
							<Row gutter={24}>
								<Col lg={8} xs={8}>
									<div>
										<Checkbox value={'task'}>
											<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
												{'Notas de tareas'}
											</Text>
										</Checkbox>
									</div>
								</Col>

								<Col lg={9} xs={9}>
									<div>
										<Checkbox value={'call'}>
											<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
												{'Notas de llamadas'}
											</Text>
										</Checkbox>
									</div>
								</Col>

								<Col lg={7} xs={7}>
									<div>
										<Checkbox value={'other'}>
											<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
												{'Otras notas'}
											</Text>
										</Checkbox>
									</div>
								</Col>
							</Row>
						</Checkbox.Group>
					) : (
						<Select
							className="filter-notes-button"
							popupClassName="filter-notes-dropdown"
							mode="multiple"
							popupMatchSelectWidth={false}
							dropdownStyle={{ width: notesVersion === 'v2' ? 220 : 160 }}
							showSearch={false}
							style={{ minWidth: 160 }}
							maxTagCount={1}
							maxTagPlaceholder={(omitted) => `+${omitted.length} más`}
							placeholder={
								<div
									style={{
										display: 'flex',
										gap: 4,
										alignItems: 'center',
										justifyContent: 'center'
									}}>
									<FilterIcon size={12} /> Filtro de notas
								</div>
							}
							dropdownRender={() => (
								<div style={{ padding: 8 }}>
									<Text>Filtro de notas</Text>
									<div style={{ marginTop: 8 }}>
										<Checkbox.Group onChange={(vals) => filterNotesV2(vals)}>
											<Checkbox value="TASKS">Tareas</Checkbox>
											<Checkbox value="OTHERS">Otras</Checkbox>
											<Checkbox value="CALLS">Llamadas</Checkbox>
											<Checkbox value="USER">Solo mis notas</Checkbox>
											<Checkbox value="DOCUMENT_MANAGER">Del gestor documental</Checkbox>
											<Checkbox value="RISK">Del analista</Checkbox>
										</Checkbox.Group>
									</div>
								</div>
							)}
							tagRender={(props) => {
								const { value, onClose } = props;
								return (
									<div className="tag-select">
										<span style={{ marginRight: 4 }}>{value}</span>
										<CloseOutlined
											onClick={onClose}
											style={{
												cursor: 'pointer',
												fontSize: 10
											}}
										/>
									</div>
								);
							}}
						/>
					)}

					<Dropdown.Button
						className="button-secundary-gibobs"
						icon={<FileSearchOutlined />}
						onClick={() => {
							setShowMortgageNoteModal(true);
						}}
						menu={{
							items: [
								{
									key: 'image-gpt',
									label: 'Nota como imagen'
								}
							],
							onClick: addNoteMenuClick
						}}>
						Añadir nota
					</Dropdown.Button>
					{contextHolder}
				</Col>
			</Row>
			<Card
				style={{
					border: '1px solid #C0DAEE',
					borderRadius: '4px',
					marginTop: '19px'
				}}>
				{notesToRender?.length > 0 ? (
					notesToRender.map((data, i) => {
						const author = notesVersion === 'v1' ? data.userFullname : data.userName;
						const date = notesVersion === 'v1' ? data.date : data.createdAt;

						return (
							<div style={{ marginBottom: '27px' }} key={`${data.userId}-${i}`}>
								<div>
									<Text
										style={{
											fontSize: '14px',
											fontWeight: '600',
											color: '#02C3CD'
										}}>
										{author}
									</Text>
									<Text
										style={{
											fontSize: '12px',
											fontWeight: 'normal',
											color: '#2F4858',
											marginLeft: '8px'
										}}>
										{moment(date).format('L')} - {moment(date).format('LT')}
									</Text>
								</div>
								<div>
									<div
										style={{
											fontSize: '12px',
											fontWeight: 'normal',
											color: '#748EA0',
											marginRight: '8px'
										}}
										dangerouslySetInnerHTML={{ __html: renderText(data.body) }}></div>
								</div>
							</div>
						);
					})
				) : (
					<Empty description="No hay notas para mostrar" style={{ marginTop: 100 }} />
				)}
				{notesVersion === 'v2' && (
					<Pagination
						size="small"
						current={requestParams.page}
						total={totalItems}
						pageSize={requestParams.limit}
						pageSizeOptions={['10', '20', '50']}
						onChange={handlePaginationChange}
						showSizeChanger={totalPages > 1}
						style={{ float: 'right', marginTop: 12 }}
						locale={{ items_per_page: '/ pag' }}
					/>
				)}
			</Card>
		</Col>
	);
}

export default FilterTask;
